<template>
    <LeftSidebar v-if="!appData.isMobile">
        <li v-for="item in navigation" :key="item.text" class="nav-link">
            <router-link
                :to="Links.Url(item.link, item.args)"
                :title="item.text"
                :class="{ active: isSelectUrl(Links.Url(item.link, item.args)) }"
            >
                <i class="icon" :class="item.icon"></i>
                <span class="link-name">{{ item.text }}</span>
            </router-link>
        </li>
    </LeftSidebar>

    <LeftSidebarMobile v-else :items="navigation" :isActive="isSelectUrl" />
</template>
<script>
    import { Links } from "@/helpers/links";
    import { appData, C } from "@/helpers/global";
    import LeftSidebar from "@/layouts/_partials/LeftSidebar.vue";

    import LeftSidebarMobile from "@/layouts/_partials/LeftSidebar.mobile.vue";

    export default {
        props: ["type"],
        components: {
            LeftSidebar,
            LeftSidebarMobile,
        },
        data() {
            return {
                appData,
                Links,
                navigation: [
                    { icon: "icon-dashboard", link: Links.Dashboard, text: "Panelim" },
                    { icon: "icon-user", link: Links.User.Profile, text: "Hesabım" },
                ],
            };
        },
        methods: {
            isSelectUrl(link) {
                if (C.Str(this.$route.path) === link) {
                    return true;
            }

                return C.Str(this.$route.path).indexOf(link.replace(/\/0/g, "")) === 0;
            },
        },
    };
</script>

